import { render, staticRenderFns } from "./FFormSubmitBtn.vue?vue&type=template&id=bf1dc7c2&"
import script from "./FFormSubmitBtn.vue?vue&type=script&lang=ts&"
export * from "./FFormSubmitBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports